var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 59,
    viewBox: "0 0 65 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1727_10534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.00304815 38.8608C0.00304815 35.9069 1.76528 33.2724 4.66182 32.0749C7.59887 30.8574 10.8803 31.496 13.1691 33.7314C15.215 35.7273 17.2608 37.7032 19.2458 39.739C19.894 40.4176 20.2788 40.3777 20.927 39.719C31.1763 29.58 41.4459 19.4809 51.6952 9.36184C53.984 7.12647 56.6578 6.36804 59.7569 7.36597C65.2056 9.12234 66.7653 15.9083 62.6129 20.0198C56.7793 25.8278 50.8849 31.5958 45.0108 37.3839C38.8126 43.4912 32.6145 49.6186 26.396 55.7259C23.3982 58.6598 19.5294 59.2586 15.9036 57.4224C14.4655 56.6839 13.4527 55.4665 12.3184 54.3687C8.95599 51.0955 5.63409 47.7823 2.29192 44.4892C0.793014 43.0122 -0.0577184 41.2159 0.00304815 38.8608ZM60.8304 14.6709C60.8304 12.5952 59.4328 11.218 57.4882 11.1182C56.1514 11.0583 55.1994 11.6771 54.3081 12.5552C43.6335 23.0934 32.9385 33.6316 22.2436 44.1698C20.4611 45.9262 19.6914 45.9262 17.8684 44.1499C15.3365 41.655 12.8248 39.1602 10.2726 36.6853C8.75344 35.2283 6.74814 35.1684 5.26949 36.4857C3.70981 37.8828 3.73007 40.0983 5.35051 41.7149C9.01676 45.3474 12.7033 48.9599 16.3695 52.5924C18.8609 55.0473 21.2714 55.0473 23.7425 52.6124C27.8949 48.5208 32.0473 44.4293 36.1997 40.3378C43.9576 32.6936 51.7154 25.0494 59.4733 17.4052C60.2835 16.6069 60.8912 15.7287 60.8304 14.6709Z",
    fill: "#BDC1DD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1727_10534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 58,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.896639a53617bfdb0f94612bf48caf0a.svg";
export { ForwardRef as ReactComponent };